import React, { useEffect } from 'react';

interface AdBannerProps {
  adSlot: string;
  adFormat?: 'auto' | 'rectangle' | 'horizontal' | 'vertical';
  style?: React.CSSProperties;
}

const AdBanner: React.FC<AdBannerProps> = ({ 
  adSlot, 
  adFormat = 'auto', 
  style 
}) => {
  useEffect(() => {
    // Only render ads on client-side and when component mounts
    if (typeof window !== 'undefined') {
      try {
        // Push the ad after the component renders
        // @ts-ignore - Google AdSense global object
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        console.log('AdSense ad push attempted for slot:', adSlot);
      } catch (e) {
        console.error('Error loading AdSense:', e);
      }
    }
    
    // Only run this effect once when the component mounts
  }, []);

  return (
    <div className="ad-container" style={{
      display: 'block',
      textAlign: 'center',
      padding: '10px 0',
      margin: '10px auto',
      overflow: 'hidden',
      backgroundColor: 'rgba(30, 30, 30, 0.5)',
      borderRadius: '4px',
      maxWidth: style?.width || 'auto',
      ...style
    }}>
      <ins
        className="adsbygoogle"
        style={{
          display: 'block',
          margin: '0 auto',
          width: '100%',
          height: style?.height || '100px',
        }}
        data-ad-client="ca-pub-2425583857483116"
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive="true"
      />
      <div style={{ fontSize: '9px', color: '#999', marginTop: '2px' }}>Advertisement</div>
    </div>
  );
};

export default AdBanner; 